// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c2DB","content":"styles_content__NQM_o","row":"styles_row__U4Igc","footer":"styles_footer__vuYtW","phraseLength":"styles_phraseLength__16KmB"};